import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
// import { getMissionList } from '@/services/egg'
import { bus } from '@tencent/vft-vue-base';
import util from '@tencent/vft-common/util';
export default {
  data: function data() {
    return {
      missionList: null
    };
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {// const { data } = await getMissionList()
                // this.missionList = data.list
              } catch (e) {
                console.error('error: ', e);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    bus.$on('gotoTask', this.gotoTask);

    if (util.getUrlParam('showMission')) {
      this.gotoTask();
    }
  },
  methods: {
    gotoTask: function gotoTask() {
      var top = this.$el.offsetTop; // 兼容性问题，二者只会有其一起作用

      document.documentElement.scrollTop = top;
      document.body.scrollTop = top;
    },
    toMissionDetail: function toMissionDetail(url) {
      if (url) {
        this.openUrl(url);
      } else {
        this.alert('开发阶段，跳转url未配置');
      }
    }
  }
};